export default __webpack_public_path__ + "static/40-fit-8f13abc2f14e36a6c3f89e51a342981e.png";